export const eventNames = {
  // Recommended page
  REC_PAGE_URL_FALLBACK: 'lb2 rec page url fallback',
  REC_PAGE_URL_VISIT: 'lb2 rec page url visit',
  REC_PAGE_REDIRECT_NO_JOB_IDS: 'lb2 rec page redirect no jobIds',
  REC_PAGE_JOB_INSTANT_BOOK: 'lb2 rec page job instant book',
  REC_PAGE_JOB_OFFER: 'lb2 rec page job offer',

  // Saved searches
  SAVED_SEARCH_APPLIED: 'lb2 saved search applied',
  SAVED_SEARCH_REMOVED: 'lb2 saved search removed',
  SAVED_SEARCH_CREATED: 'lb2 saved search created',

  // Staged jobs
  STAGED_JOBS_UNSTAGE_JOB_CLICKED: 'lb2 staged jobs unstage job clicked',
  STAGED_JOBS_PAGE_LOADED: 'lb2 staged jobs page loaded',
  STAGED_JOBS_REFRESH_CLICKED: 'lb2 staged jobs refresh clicked',
  STAGED_JOBS_BOOKED: 'lb2 staged jobs booked',
  STAGED_JOBS_ROWS_PER_PAGE_CHANGED: 'lb2 staged jobs rows per page changed',
  STAGED_JOBS_PAGE_CHANGED: 'lb2 staged jobs page changed',
  STAGED_JOBS_MODAL_TOGGLED: 'lb2 staged jobs modal toggled',

  // Manage jobs
  MANAGE_LIST_VIEW_TOGGLED: 'lb2 manage list view toggled',
  MANAGE_LIST_MAP_CLICKED: 'lb2 manage list map clicked',
  MANAGE_LIST_EXPORT_CSV_CLICKED: 'lb2 manage list export csv clicked',
  MANAGE_LIST_ROWS_PER_PAGE_CHANGED: 'lb2 manage list rows per page changed',
  MANAGE_LIST_PAGE_CHANGED: 'lb2 manage list page changed',
  MANAGE_LIST_MORE_DETAILS_CLICKED: 'lb2 manage list more details clicked',
  MANAGE_LIST_UPDATE_THIS_JOB_CLICKED: 'lb2 manage list update this job clicked',

  // Status updates
  STATUS_UPDATE_BUTTON_CLICKED: 'lb2 status update button clicked',
  STATUS_UPDATE_DATE_CHANGED: 'lb2 status update date changed',
  ETA_UPDATE_BUTTON_CLICKED: 'lb2 eta update button clicked',
  ETA_UPDATE_CANCELLED: 'lb2 eta update date canceled',
  ETA_UPDATE_DATE_CHANGED: 'lb2 eta update date changed',
  ETA_UPDATE_FAILED: 'lb2 eta update button click failed',
  ETA_PAST_ACCEPTABLE_DELIVERY_RANGE: 'lb2 eta job past acceptable delivery range',

  // Carrier note / documents
  CARRIER_NOTE_SUBMITTED: 'lb2 update job carrier note submitted',
  DOCUMENT_DOWNLOAD_CLICKED: 'lb2 update job document download clicked',
  EBOL_UPLOAD_CLICKED: 'lb2 update job ebol upload clicked',
  EBOL_DELETE_CLICKED: 'lb2 update job ebol delete clicked',

  // Cancel job
  CANCEL_JOB_SUBMITTED: 'lb2 update job cancel submitted',
  CANCEL_DIALOG_OPEN: 'lb2 manage cancel open dialog',
  CANCEL_DIALOG_ACCEPT: 'lb2 manage cancel accept',
  CANCEL_DIALOG_KEEP: 'lb2 manage cancel keep job',

  // Job list
  JOBS_LIST_JOB_CARD_CLICKED: 'lb2 job details called on job card click',
  JOBS_LIST_STAGE_JOBS_CLICKED: 'lb2 jobs list stage jobs clicked',
  JOBS_LIST_MODAL_TOGGLED: 'lb2 jobs list modal toggled',
  JOBS_MODAL_STAGE_JOBS_CLICKED: 'lb2 jobs modal stage jobs clicked',
  JOBS_LIST_CHECKBOX_CHECKED: 'lb2 jobs list checkbox checked',
  JOBS_LIST_CHECKBOX_UNCHECKED: 'lb2 jobs list checkbox unchecked',
  MAX_JOB_COUNT_EXCEEDED: 'lb2 max job count exceeded on Job List load',
  JOBS_LIST_REFRESH_CLICKED: 'lb2 jobs list refresh clicked',
  JOBS_LIST_ROWS_PER_PAGE_CHANGED: 'lb2 jobs list rows per page changed',
  JOBS_LIST_PAGE_CHANGED: 'lb2 jobs list page changed',
  PENDING_OFFER_JOB_INSTANT_BOOKED: 'lb2 pending offer job instant booked',
  JOB_INSTANT_BOOKED_STAGE_AND_BOOK: 'lb2 job instant booked with stageAndBookJob',

  // Bundle modal
  JOBS_BUNDLE_MODAL_STAGE_JOBS_CLICKED: 'lb2 jobs bundle modal stage jobs clicked',
  BUNDLE_MODAL_BACKHAUL_TABS_TOGGLED: 'lb2 bundle modal backhaul tabs toggled',

  // Profile / navigation
  PROFILE_MENU_CLICKED: 'lb2 profile menu clicked',
  LOGOUT_BUTTON_CLICKED: 'lb2 logout button clicked',
  PROFILE_SEND_FEEDBACK_BUTTON_CLICKED: 'lb2 profile send feedback button clicked',
  LEGAL_BUTTON_CLICKED: 'lb2 legal button clicked',
  TUTORIALS_BUTTON_CLICKED: 'lb2 tutorials button clicked',
  CUSTOMER_SUPPORT_BUTTON_CLICKED: 'lb2 customer support button clicked',
  DESKTOP_CARRIER_PROFILE_LINK_CLICKED: 'lb2 desktop carrier-profile link clicked',
  CARRIER_PROFILE_INTERNAL_LINK_CLICKED: 'lb2 carrier-profile internal link clicked',
  MOBILE_CARRIER_PROFILE_LINK_CLICKED: 'lb2 mobile carrier-profile link clicked',
  PROFILE_MOBILE_MENU_CLICKED: 'lb2 profile mobile menu clicked',

  // Misc
  INSTRUCTIONS_LANGUAGE_CHANGED: 'lb2 instructions language changed',
  MAP_LINK_CLICKED: 'lb2 edit job map link clicked',
  NEGOTIATED_RATE_CHANGED: 'negotiated_rate_changed',

  // Feature announcements
  FEATURE_ANNOUNCEMENT_MODAL_SHOWN: 'lb2 feature announcement modal shown',
  FEATURE_ANNOUNCEMENT_CARD_VIEWED: 'lb2 feature announcement card viewed',
  FEATURE_ANNOUNCEMENT_WALKTHROUGH_STARTED: 'lb2 feature announcement walkthrough started',
  FEATURE_ANNOUNCEMENT_WALKTHROUGH_COMPLETED: 'lb2 feature announcement walkthrough completed',
  FEATURE_ANNOUNCEMENT_WALKTHROUGH_CANCELLED: 'lb2 feature announcement walkthrough cancelled',
  WHATS_NEW_PANEL_OPENED: 'lb2 whats new panel opened',
  WHATS_NEW_PANEL_ITEM_CLICKED: 'lb2 whats new panel item clicked',

  // Get started
  GETSTARTED_CATEGORY_VIEWED: 'lb2 get started category viewed',
  GETSTARTED_TOPIC_STARTED: 'lb2 get started topic started',
  GETSTARTED_DISMISSED: 'lb2 get started dismissed',
  GETSTARTED_DONT_SHOW_AGAIN_CLICKED: 'lb2 get started dont show again clicked',
  GETSTARTED_TOPIC_COMPLETED: 'lb2 get started topic completed',
  GETSTARTED_TOPIC_CANCELLED: 'lb2 get started topic cancelled',
};
